import { I18nProvider } from '@silospot/i18n/react';
import type { ReactElement, ReactNode } from 'react';
import { useLocaleStore } from '../stores/locale-store';

/** Wires the active locale (from the store) into the i18next provider. */
export function I18nGate({ children }: { children: ReactNode }): ReactElement {
  const locale = useLocaleStore((state) => state.locale);
  return <I18nProvider locale={locale}>{children}</I18nProvider>;
}
